/* Keep the collapsed Inbox launcher clear of visible shop controls. */
(() => {
  const selector = 'button, input:not([type="hidden"]), select, textarea, summary, a, [role="button"], [role="link"], .shopify-payment-button';
  let frame = 0;
  let retries = 0;

  const intersects = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  // Inbox may expose the activator directly or through its agent runtime.
  const findLauncher = chat => chat?.shadowRoot?.querySelector('[part~="activator"]') ||
    chat?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="activator"]');
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(check);
  };
  function check() {
    frame = 0;
    const chat = document.querySelector('shopify-chat');
    const launcher = findLauncher(chat);
    if (!chat || !launcher) return;
    const runtime = chat.shadowRoot?.querySelector('shopify-agent-runtime');
    if (chat.hasAttribute('open') || runtime?.hasAttribute('open') || launcher.getRootNode().activeElement === launcher) {
      chat.removeAttribute('data-jl-obstructed');
      return;
    }
    const button = launcher.getBoundingClientRect();
    if (!button.width || !button.height) return;
    const dialogOpen = [...document.querySelectorAll('dialog[open]')].some(dialog => !dialog.contains(chat));
    const blocked = dialogOpen || [...document.querySelectorAll(selector)].some(element => {
      if (chat.contains(element) || element.closest('shopify-chat, [hidden], [inert]')) return false;
      const rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height || !intersects(button, rect)) return false;
      // Large linked photos and whole-card links are content, not small controls.
      if (element.matches('a') && rect.height > 180) return false;
      const style = getComputedStyle(element);
      return style.visibility !== 'hidden' && style.display !== 'none' && style.pointerEvents !== 'none';
    });
    if (blocked !== chat.hasAttribute('data-jl-obstructed')) {
      chat.toggleAttribute('data-jl-obstructed', blocked);
    }
  }

  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'inert'] });
  const retry = setInterval(() => {
    schedule();
    if (findLauncher(document.querySelector('shopify-chat')) || ++retries >= 30) clearInterval(retry);
  }, 500);
  schedule();
})();
